import { LogoutOptions, useAuth0 } from '@auth0/auth0-react'
import { havelockAuthContext } from '@lib/context/HavelockAuthContext/HavelockAuthContext'
import { setOrganizationId } from '@lib/graphql/variables/organizationId'
import { AUTH_LOGOUT_STATE } from '@utils/localStorage'
import { useCallback } from 'react'

const useLogout = () => {
  const { logout: logoutProdactive } = useAuth0()
  const { logout: logoutHavelock } = useAuth0(havelockAuthContext)

  const logoutClient = useCallback(
    (options?: LogoutOptions) => {
      logoutProdactive(options)
      logoutHavelock({
        openUrl: false,
      })

      localStorage.setItem(AUTH_LOGOUT_STATE, Date.now().toString())
      sessionStorage.clear()
      setOrganizationId(null)
    },
    [logoutProdactive, logoutHavelock]
  )

  return { logoutClient }
}

export default useLogout
